import styles from './CardBody.module.css'

function CardBody({
  id = null,
  children,
  style = null,
  cardBodyRef,
}) {
  return (
    <div
      id={id}
      className={styles.cardBody}
      style={style}
      ref={cardBodyRef}
    >
      {children}
    </div>
  )
}

export default CardBody
